import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { Provider } from 'react-redux';
import store, { persistor } from './store';
import { PersistGate } from 'redux-persist/integration/react';

import { setAuthHandlers } from './api/axios'; // Import
import { updateAccessToken, logout } from './features/auth/authSlice';

// ✅ 在应用启动时，注入 API 的认证回调（最稳：可拿到最新 store）
setAuthHandlers({
  getToken: () => store.getState().auth.accessToken,
  onRefreshSuccess: (newToken) => store.dispatch(updateAccessToken(newToken)),
  onForceLogout: () => store.dispatch(logout()),
});

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <BrowserRouter>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </BrowserRouter>
);
